import { render, staticRenderFns } from "./CustomerPicker.vue?vue&type=template&id=0ead94d4&scoped=true&"
import script from "./CustomerPicker.vue?vue&type=script&lang=js&"
export * from "./CustomerPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ead94d4",
  null
  
)

export default component.exports